import React from 'react';
import { connect } from 'react-redux'
import connectCommon from '../common/common-hoc';
import * as actionCreator from '../../redux/actions/data-action';
import { TaskType, TaskSegment, getTaskTypeIdByType, getTaskTypeIdById } from '../../redux/actions/data-action';
import { aiVersions } from '../../Constants';

import { getInstructionComponent } from './instructions';
import { getPracticeComponent } from './practice-tasks';
import { getPracticeCompleteComponent } from './practices';
import { getTaskComponent } from './tasks';
import { useLastLocation, withLastLocation } from 'react-router-last-location';

class AssessmentTasks extends React.Component {
    getNextType(type) {
        const { tasks } = this.props;
        const currentTaskType = getTaskTypeIdByType(type);

        const currentTaskIndex = tasks.map(task => task.id).indexOf(currentTaskType.id);

        if (currentTaskIndex + 1 < tasks.length) {
            const nextTaskType = getTaskTypeIdById(tasks[currentTaskIndex + 1].id);
            return nextTaskType.type;
        } else {
            return null;
        }
    }

    getPreviousType(type) {
        const { tasks } = this.props;
        const currentTaskType = getTaskTypeIdByType(type);

        const currentTaskIndex = tasks.map(task => task.id).indexOf(currentTaskType.id);

        if (currentTaskIndex - 1 >= 0) {
            const prevTaskType = getTaskTypeIdById(tasks[currentTaskIndex - 1].id);
            return prevTaskType.type;
        } else {
            return null;
        }
    }

    getPreviousLink(type, segment, hasPractice) {
        if (!segment) {
            segment = TaskSegment.INSTRUCTION;
        }

        switch (segment) {
            case TaskSegment.INSTRUCTION:
                const prevType = this.getPreviousType(type);

                if (prevType) {
                    const lastIndex = this.getLastTaskIndex(type, TaskSegment.TASK) + 1;

                    return `/Assessment/Tasks/${prevType}/${TaskSegment.TASK}/${lastIndex}`;
                } else {
                    return "/Assessment/Instruction";
                }
            case TaskSegment.PRACTICE:
                return `/Assessment/Tasks/${type}/${TaskSegment.INSTRUCTION}`;
            case TaskSegment.PRACTICECOMPLETE:
                const lastIndex = this.getLastTaskIndex(type, TaskSegment.PRACTICE) + 1;
                return `/Assessment/Tasks/${type}/${TaskSegment.PRACTICE}/${lastIndex}`;
            case TaskSegment.TASK:
                return hasPractice ? `/Assessment/Tasks/${type}/${TaskSegment.PRACTICECOMPLETE}` : "/Assessment/Instruction"
            default:
                return "Assessment/Instruction";
        }
    }

    getNextLink(type, segment, hasPractice, hasOutcomes) {

        if (!segment) {
            segment = TaskSegment.INSTRUCTION;
        }

        const currentItemIndex = this.getCurrentItemIndex();

        switch (segment) {
            case TaskSegment.INSTRUCTION:
                return hasPractice ? `/Assessment/Tasks/${type}/${TaskSegment.PRACTICE}/1` : `/Assessment/Tasks/${type}/${TaskSegment.TASK}/1`;
            case TaskSegment.PRACTICE:
                return `/Assessment/Tasks/${type}/${TaskSegment.PRACTICECOMPLETE}`;
            case TaskSegment.PRACTICECOMPLETE:
                return `/Assessment/Tasks/${type}/${TaskSegment.TASK}/1`;
            case TaskSegment.TASK:
                const nextType = this.getNextType(type);

                var version = parseInt(sessionStorage.getItem('temp-version-id'));

                if (nextType) {
                    return `/Assessment/Tasks/${nextType}/${TaskSegment.INSTRUCTION}`;
                } else if (currentItemIndex === this.getLastTaskIndex(type, segment)) {      
                    return hasOutcomes ? "/Assessment/Outcome/Instruction" : version === 3 || version === 4 || version === 5 || version === 6 ? "/PostAdmin/ConcernsStrengths" : '/Demographic/AdditionalQuestions/1';
                }
                break;
            default:
                return hasOutcomes ? "/Assessment/Outcome/Instruction" : version === 3 || version === 4 || version === 5 || version === 6 ? "/PostAdmin/ConcernsStrengths" : "/Assessment/Complete";
        }
    }

    getCurrentItemIndex() {
      let currentIndex = 0;

      const { match } = this.props;
      const index = match.params.index;

      if (index !== undefined) {
          currentIndex = index - 1;
      }

      return currentIndex;
    }

    getLastTaskIndex(type, segment) {
        const { tasks } = this.props;
        const currentTaskType = getTaskTypeIdByType(type);

        const currentTaskIndex = tasks.map(task => task.id).indexOf(currentTaskType.id);

        let currentTasks = []

        if (segment === TaskSegment.TASK) {
            currentTasks = tasks[currentTaskIndex].tasks;
        } else if (segment === TaskSegment.PRACTICE) {
            currentTasks = tasks[currentTaskIndex].practice;
        }

        for (let i = currentTasks.length - 1; i >= 0; i--) {
            if (currentTasks[i].skipped) {
                continue;
            } else {
                return i;
            }
        }
    }

    getTaskLink(type, segment) {
        return `/Assessment/Tasks/${type}/${TaskSegment.TASK}`;
    }

    getPracticeTaskLink(type, segment) {
        return `/Assessment/Tasks/${type}/${TaskSegment.PRACTICE}`;
    }

    render() {
        const { tasks } = this.props;
        const { type, segment, index } = this.props.match.params;

        const currentTaskType = getTaskTypeIdByType(type);

        const currentTaskIndex = tasks.map(task => task.id).indexOf(currentTaskType.id);

        var hasPractice = tasks[currentTaskIndex].practice.length > 0;
        
        var hasOutcomes = this.props.outcomes.length > 0

        const nextLink = this.getNextLink(type, segment, hasPractice, hasOutcomes);
        const previousLink = this.getPreviousLink(type, segment, hasPractice);
        const taskLink = this.getTaskLink(type, segment);
        const practiceTaskLink = this.getPracticeTaskLink(type, segment);

        switch (segment) {
            case TaskSegment.INSTRUCTION:
                const Instruction = getInstructionComponent(type);
                return (
                    <Instruction {...this.props} previousLink={previousLink} nextLink={nextLink}  />
                )
            case TaskSegment.PRACTICE:
                const Practice = getPracticeComponent(type);
                return (
                    <Practice {...this.props} previousLink={previousLink} nextLink={nextLink} taskLink={practiceTaskLink} />
                )
            case TaskSegment.PRACTICECOMPLETE:
                const PracticeComplete = getPracticeCompleteComponent(type);
                return (
                    <PracticeComplete {...this.props} previousLink={previousLink} nextLink={nextLink} />
                )
            case TaskSegment.TASK: {
                const Task = getTaskComponent(type);

                return (
                    <Task {...this.props} previousLink={previousLink} nextLink={nextLink} taskLink={taskLink} />
                )
            }
            default:
                return (
                    <Instruction {...this.props} previousLink={previousLink} nextLink={nextLink} />
                )
        }
    }
}

const mapStateToProps = (state, ownState) => ({
    tasks: state.data.tasks,
    outcomes: state.data.outcomes
})

export default connect(mapStateToProps, actionCreator)(connectCommon(AssessmentTasks));